import { setItemToStorage } from '@rfc/rfc-components-library/utils'
import type { Commit } from 'vuex'
import { ELocalStorage } from '../../types/enum/LocalStorageEnum'
import { EFiltersActions } from './FiltersStoreTypes'

const actions = {
    [EFiltersActions.SET_FILTER]: (
        { commit }: { commit: Commit },
        filter: Record<string, string | number | boolean>
    ) => setItemToStorage(ELocalStorage.FILTERS, filter)
}

export default {
    namespaced: true,
    actions
}
